import { useHasPermission } from '@clean-code/hooks/usePermissions';

export interface ProductionPermissions {
  canCreate: boolean;
  canModify: boolean;
  canDelete: boolean;
  canModifyNominalSpeed: boolean;
}

/**
 * Per-role gate for writing production data. Backed by the configurable
 * permission matrix.
 */
export const useProductionPermissions = (): ProductionPermissions => {
  const hasPermission = useHasPermission();
  const canModify = hasPermission('production', 'modify');
  return {
    canCreate: hasPermission('production', 'create'),
    canModify,
    canDelete: hasPermission('production', 'delete'),
    // A sub-permission of modify: it can narrow what modify allows, never widen it.
    canModifyNominalSpeed:
      canModify && hasPermission('production', 'nominal_speed.modify')
  };
};
